import Gatspy from '../assets/png/gatsby.png'
import Deadlock from '../assets/png/deadlock.png'
import Redux from '../assets/png/redux.png'

export const blogData = [
    {
        id: 1,
        title: 'Deadlock',
        description: 'Post on Instagram talking about Deadlock',
        date: 'Feb 26, 2022',
        image: Deadlock,
        url: 'https://www.instagram.com/code.afternoon/'
    },
    {
        id: 2,
        title: 'Redux',
        description: 'Post on Instagram talking about Redux',
        date: 'Jul 8, 2022',
        image: Redux,
        url: 'https://www.instagram.com/code.afternoon/'
    },
    {
        id: 3,
        title: 'Gatsby',
        description: 'Post on Instagram talking about Gatsby and how you can use it beside GraphQL to boost your website\'s performance',
        date: 'Dec 19, 2022',
        image: Gatspy,
        url: 'https://www.instagram.com/code.afternoon/'
    },
]
